<button mat-icon-button class="close-button" [mat-dialog-close]="true"  tabindex="-1">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<mat-dialog-content class="modal_container">

    <div class="container_frame">
        <iframe id="content-iframe" class="responsive_iframe" title="onboarding"></iframe>
    </div>

</mat-dialog-content>